<template>
	<b-card class="p-1 mb-0" :class="{'profile-warning':hasWarning}" no-body>
		<span v-if="hasWarning" class="material-icons-round warning-icon">report</span>
		<div class="row align-items-center">
			<div class="col-sm-auto">
				<div class="profile-image-wrapper">
					<div class="profile-image">
						<b-avatar v-if="info" v-on:img-error="error = true" size="114" variant="light" :src="image"/>
						<b-skeleton v-else height="114px" width="114px" type="avatar"></b-skeleton>
					</div>
				</div>
			</div>
			<div class="col-sm ml-sm-2 mt-sm-0 mt-2 text-sm-left text-center">
				<div class="d-flex align-items-center mb-50">
					<collar-status v-if="$safe(info,'CollarStatus') != null" :code="$safe(info,'CollarStatus.Code')" tooltip :name="$safe(info,'CollarStatus.Name')" small></collar-status>
					<h6 class="text-primary mb-0 ml-50" v-if="currentBranch"><strong>{{ currentBranch }}</strong> - {{currentTitle}} <span class="text-muted" v-if="jobStartDate"> | {{jobStartDate}}</span></h6>
				</div>
				<h3 v-if="$safe(info,'FirstName')" class="font-weight-bolder d-flex justify-content-sm-start justify-content-center">
					{{$safe(info,'FirstName')}} {{$safe(info,'LastName')}}
					<span class="material-icons-outlined text-success ml-50" v-if="$safe(info,'HasUser')" v-b-tooltip.noninteractive.hover.bottom="'Sistem Kullanıcısı'">
						how_to_reg
					</span>
				</h3>
				<b-skeleton v-else width="15%"></b-skeleton>
				<b-badge v-if="$safe(info,'RegistrationCode')" class="profile-badge" variant="light-primary">{{$safe(info,'RegistrationCode')}}</b-badge>
				<b-badge v-if="$safe(info,'IdentityNumber')" class="profile-badge ml-50" variant="light-secondary">K.N.: {{$safe(info,'IdentityNumber')}}</b-badge>
				<b-badge v-if="showEmailWarning" class="profile-badge ml-50" variant="danger"v-b-tooltip.noninteractive.hover.bottom="'Beyaz yakalı personel için varsayılan e-posta bilgisi kaydedilmemiş'">
					<feather-icon icon="AlertTriangleIcon" size="14" class="mr-25"></feather-icon> Varsayılan E-posta Eksik
				</b-badge>
			</div>
		</div>
	</b-card>
</template>

<script>
import { BCard, BAvatar, BBadge,BSkeleton,VBTooltip } from 'bootstrap-vue'
import CollarStatus from '../../components/CollarStatus.vue'

export default {
	props:{
		info:Object,
		hasWarning:{
			type:Boolean,
			default:false
		},
		employeeBranch:Object,
		sgkEntry:Object,
		showEmailWarning:{
			type:Boolean,
			default:false
		}
	},
	components: {
		BCard,
		BBadge,
		BAvatar,
		BSkeleton,
		CollarStatus
	},
	directives:{
		'b-tooltip':VBTooltip
	},
	data(){
		return{
			error:false
		}
	},
	watch:{
		"info.File"(){
			this.error = false
		}
	},
	computed:{
		image(){
			if(this.info.File && !this.error){
				return this.info.File
			}else{
				return require('@/assets/images/avatars/no-user-pic.svg')
			}
		},
		currentBranch(){
			return this.employeeBranch.Current?.Branch?.Name || null
		},
		currentTitle(){
			return this.employeeBranch.Current?.EmployeeDepartmentTitle?.Name || null
		},
		jobStartDate(){
			return this.sgkEntry?.NotifyDate || null
		}
	}
}
</script>

<style>
	.profile-image-wrapper{
		display: flex;
		justify-content: center;
	}
	.profile-image-wrapper .profile-image {
		border-radius: 50%;
		background-color: #fff;
	}
	.profile-image-wrapper .profile-image img {
		width: 100px;
		height: 100px;
    }
	.profile-warning{
		box-shadow: inset 0px 0px 0px 3px rgba(239, 91, 12,0.7);
		background-color: rgba(239, 91, 12,0.1);
		overflow: hidden;
	}
	.profile-warning .warning-icon{
		font-size: 210px;
		position: absolute;
		right: 1rem;
		display: block;
		top: 50%;
		transform: translate(40%,-50%);
		color: rgba(239, 91, 12,0.2);
	}
</style>
